module.exports = __webpack_public_path__ + "static/0053-2450c9a18f76868c46aedea964b86701.png";